// Every figure /how_it_works shows, in one place, with where it came from.
//
// The film and the page text both read this module, so a number cannot say one
// thing in the video and another in the paragraph under it. Each entry names
// its source and the date it was read; a figure with no source does not belong
// here.
//
// What this page may say is narrower than what we know. The learning engine is
// closed technology and its patent filing is in progress, so the page carries
// outcomes and measured numbers only, never how the engine is built. That holds
// for these comments too: production ships source maps, so they are public.
// HowItWorks.test.js reads this file and fails on the mechanism words.

// Read from the learning engine's own counters on one home PC running Nunba,
// 10 Oct 2026.
export const LIVE_READ_ON = '10 October 2026';

export const LIVE = {
  // every learning event this node has run
  events: 6745,
  // updates whose error was measured before and after
  measured: 3011,
  // measured updates that made its guess worse
  harmful: 213,
};

// round((3011 - 213) / 3011 * 100) = 93; round(213 / 3011 * 100) = 7
export const LIVE_HARMFUL_PCT = Math.round((LIVE.harmful / LIVE.measured) * 100);
export const LIVE_OK_PCT = 100 - LIVE_HARMFUL_PCT;

// Confidence read-out on the same node, 4 to 9 Oct 2026. Before each update is
// checked the learner states how likely its guess is to be good, and it keeps a
// running score of those statements against a fixed guess at the base rate
// (Brier skill over its recent window). At 359 of the 443 live check-points
// that score was positive: its own confidence out-predicted the fixed guess.
// It is a recent-window score, so it moves; it is quoted as a share of
// check-points, never as one number.
export const CONFIDENCE = { events: 443, beat: 359 };
export const CONFIDENCE_PCT = Math.round((CONFIDENCE.beat / CONFIDENCE.events) * 100);

// Median wall time of a learning event on the same PC, 23 consecutive events
// after a restart on 8 Oct 2026. It runs in the background while Nunba answers.
export const EVENT_SECONDS = 12.7;

// The published benchmark ("The Node That Keeps What It Learns", July 2026):
// learn task A, then task B, then measure how much worse A got (`label`, where
// 1.00x means no measurable loss), and the post's "learns from one example"
// column (`one`). Same protocol for every system, 4-core CPU, no GPU. The
// language-model row is left out: its weights never change, so neither column
// applies to it.
export const RETENTION = [
  { name: 'HevolveAI', worse: 1.0, label: '1.00x', one: '100%', ours: true },
  { name: 'Transformer, fine-tuned', worse: 5.95, label: '5.95x', one: '24.2%' },
  { name: 'Plain network, fine-tuned', worse: 59.7, label: '59.7x', one: '9.2%' },
  { name: 'World model, with replay', worse: 61.4, label: '61.4x', one: '11.9%' },
  { name: 'Same, replay removed', worse: 24888, label: '24,888x', one: '12.2%' },
];

export const BENCHMARK_POST = '/blog/the-node-that-keeps-what-it-learns';

export const fmtInt = (n) => Number(n).toLocaleString('en-US');
